export default function () {
    window.Calendly.initPopupWidget({url: 'https://calendly.com/pigeonmedical/15min'});
}